const assets = {
  images: {
    logo: require('./img/logo/Marca.webp'),
    logoSidebar: require('./img/logo/MarcaWhite.png'),
    brinco: require('./img/mockupProduto/brinco.png'),
    brincoLaranja: require('./img/mockupProduto/SER-2-5-411x565-1.webp'),
    logoPDF: require('./img/logo/pdfLogo.png'),
    produto: require('./img/produto.webp'),
    bgCheckout: require('./img/bg-checkout.png'),
  },
};

export default assets;
